import { useForm } from 'react-hook-form';

import { TProgramForm } from '@/features/programs/types';

export function useProgramDrawerFormState() {
  const form = useForm<TProgramForm>({
    mode: 'all',
    defaultValues: {
      state: 'inactive',
      audience_program_source_id: '',
      channel_id: '',
      description: '',
      end_datetime: null,
      id: '',
      language_id: '',
      language_transcription_id: '',
      name: '',
      parameters: {
        link_with_channel_enrichments: true,
      },
      priority: null,
      program_category_id: '',
      program_classification: '',
      program_viewed_place_id: '',
      schedule: [],
      start_datetime: null,
      uri: '',
    },
  });

  return { form };
}
